import React from 'react';
import { Header } from '../components/Header';
import { Hero } from '../components/Hero';
import { TestimonialBox } from '../components/TestimonialBox';
import { ProductSidebar } from '../components/ProductSidebar';
import { CTASection } from '../components/CTASection';
import { StickyBottomBar } from '../components/StickyBottomBar';
export function AdvertorialPage() {
  const testimonials = [{
    author: 'Sarah M., 44',
    location: 'Austin, TX',
    quote: 'After 12 years of nightly wine, I stopped wanting it in week one. Week one. My husband says he has his wife back. I say I have myself back.'
  }, {
    author: 'Jennifer K., 39',
    location: 'Denver, CO',
    quote: "The 3 AM wake-ups were destroying me. I'd lie there in panic for hours. Now I sleep through the night. My anxiety is just... gone. I can't believe something so simple worked when therapy didn't."
  }, {
    author: 'Michelle R., 52',
    location: 'Portland, OR',
    quote: "I spent over $6,000 on therapy trying to quit. This patch did what 18 months of therapy couldn't—it calmed my nervous system down. Within 10 days the craving went from a 9 to a 2."
  }, {
    author: 'Rachel T., 36',
    location: 'Charlotte, NC',
    quote: "I can finally be the mom I wanted to be. Present at bedtime. Patient when my kids need me. Proud of who I am. I didn't know life could feel this calm."
  }, {
    author: 'Lisa W., 48',
    location: 'Seattle, WA',
    quote: "I tried AA, naltrexone, supplements, everything. Nothing worked. This patch was the first thing that actually addressed WHY I was drinking—my nervous system was fried. Two weeks in and I'm a different person."
  }];
  return <div className="min-h-screen bg-white font-sans text-gray-900" data-id="element-138">
      <Header data-id="element-139" />

      <main className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8" data-id="element-140">
        <div className="flex flex-col lg:flex-row gap-12" data-id="element-141">
          {/* Main Content Column */}
          <article className="w-full lg:w-[65%]" data-id="element-142">
            <Hero data-id="element-143" />

            {/* IMAGE 1: Emotional disconnection at breakfast - RIGHT AFTER HEADLINE */}
            <div className="my-8 rounded-lg overflow-hidden shadow-sm" data-id="element-144">
              <img src="https://cdn.magicpatterns.com/uploads/hpZoyrKXNKJ1EcCdKC7wkN/ChatGPT_Image_10_Ιαν_2026,_11_55_32_π.μ..png" alt="Mother sitting at kitchen table with coffee looking defeated, daughter with headphones in background not looking at her, wine bottles visible" className="w-full h-auto rounded-lg" data-id="element-145" />
            </div>

            <div className="prose prose-lg max-w-none text-gray-800 font-serif leading-relaxed" data-id="element-146">
              <p className="text-xl mb-6 font-semibold text-gray-900" data-id="element-147">
                I still remember that Tuesday morning like it was yesterday.
              </p>

              <p className="mb-6" data-id="element-148">
                I walked into the kitchen at 7:15 AM, head pounding, mouth dry
                as sandpaper. My 14-year-old daughter Emma was already at the
                table, headphones in, staring at her cereal bowl.
              </p>

              <p className="mb-6" data-id="element-149">
                She didn't look up when I sat down. She didn't look up when I
                poured my coffee. She didn't look up at all.
              </p>

              <p className="mb-6" data-id="element-150">
                That crushing, hollow feeling in my chest wasn't just a
                hangover. It was knowing I needed to quit—and being absolutely
                terrified of what would happen if I tried.
              </p>

              <p className="mb-6" data-id="element-151">
                Because I'd Googled it. I'd read the Reddit threads at 2 AM. I
                knew what they called it:
              </p>

              <p className="mb-6 text-2xl font-bold text-gray-900" data-id="element-152">
                The 72-hour danger zone.
              </p>

              <p className="mb-6" data-id="element-153">
                Doctors say the first three days when you try to quit drinking
                are the most dangerous. That's when withdrawal symptoms hit
                hardest. When your body goes into panic mode. When people end up
                in the ER with seizures, heart palpitations, full-blown panic
                attacks.
              </p>

              <p className="mb-6" data-id="element-154">
                I'd tried once before. Thirty-six hours in, I was shaking so
                badly I couldn't hold a coffee mug. My heart was racing like I'd
                run a marathon. The panic was so overwhelming I started drinking
                again just to survive.
              </p>

              <p className="mb-6" data-id="element-155">
                So I kept drinking. Not because I wanted to. But because the
                danger zone terrified me more than the shame of watching my
                daughter pull away.
              </p>

              <p className="mb-6" data-id="element-156">
                Every night I'd pour that first glass and think: "Tomorrow. I'll
                quit tomorrow."
              </p>

              <p className="mb-6" data-id="element-157">
                But tomorrow never came. Because the 72-hour danger zone was
                always waiting.
              </p>

              <div className="bg-amber-50 border-l-4 border-amber-500 p-6 my-8" data-id="element-158">
                <p className="text-amber-900 font-medium italic" data-id="element-159">
                  If you've ever been too scared to quit because you've heard
                  about withdrawal—if you've Googled "alcohol withdrawal
                  symptoms" at 2 AM and felt your stomach drop—I need you to
                  keep reading.
                </p>
                <p className="text-amber-900 font-bold mt-4" data-id="element-160">
                  Because what I discovered eliminated the danger zone
                  completely. And it let me quit without a single scary symptom.
                </p>
              </div>

              <h2 className="text-2xl md:text-3xl font-bold text-gray-900 mt-12 mb-6 font-sans" data-id="element-161">
                The Nightly Cycle I Couldn't Break
              </h2>

              <p className="mb-6" data-id="element-162">
                It happened the same way every single night.
              </p>

              <p className="mb-6" data-id="element-163">
                I'd wake up that morning with the familiar shame hangover—the
                physical pain mixed with the emotional torture of broken
                promises. I'd stand in the shower letting the water run over me,
                making the same vow I'd made hundreds of times before: "Not
                tonight. Tonight I'm different."
              </p>

              <p className="mb-6" data-id="element-164">And I meant it. I really did.</p>

              <p className="mb-6" data-id="element-165">
                I'd make it through the workday. Get through the afternoon.
                Start making dinner with actual determination to stay in
                control.
              </p>

              <p className="mb-6" data-id="element-166">Then 7 PM would roll around.</p>

              <p className="mb-6" data-id="element-167">
                That's when it would hit. That screaming urge that started in my
                chest and spread through my entire body. The mental noise that
                drowned out everything else: "Just one glass. You've earned it.
                You've been good all day. Just one won't hurt."
              </p>

              <p className="mb-6" data-id="element-168">
                One glass turned into two. Two turned into "I'll just finish
                this bottle." Before I knew it, I was opening a second bottle
                and the night became a blur.
              </p>

              {/* IMAGE 2: Wine bottles and the nightly ritual */}
              <div className="my-8 rounded-lg overflow-hidden shadow-sm" data-id="element-169">
                <img src="https://cdn.magicpatterns.com/uploads/nrKnszkQKZbSsztMMBA8WE/ChatGPT_Image_10_Ιαν_2026,_11_55_30_π.μ..png" alt="Kitchen counter at 7 PM with wine bottles and glass, woman's hands opening another bottle" className="w-full h-auto rounded-lg" data-id="element-170" />
              </div>

              <p className="mb-8" data-id="element-171">
                The worst part? I'd wake up at 3 AM in a panic—heart racing,
                sheets drenched in sweat, replaying conversations I couldn't
                fully remember. Did I say something awful to my husband? Was I
                slurring when Emma asked me to help with homework?
              </p>

              <p className="mb-6 font-bold text-gray-900" data-id="element-172">
                The anxiety was crushing. The shame was unbearable.
              </p>

              <p className="mb-8" data-id="element-173">
                And the next morning, the cycle would start all over again.
              </p>

              <h2 className="text-2xl md:text-3xl font-bold text-gray-900 mt-12 mb-6 font-sans" data-id="element-174">
                I Tried Everything (And Failed at All of It)
              </h2>

              <p className="mb-6" data-id="element-175">
                If you're reading this, you've probably tried some of these too.
              </p>

              <p className="mb-6" data-id="element-176">
                I made rules. Only on weekends. Only two glasses. Only after 8
                PM. I'd follow them for three days, maybe a week, then break
                them. The guilt from breaking my own rules only made me drink
                more.
              </p>

              <p className="mb-6" data-id="element-177">
                I downloaded apps that tracked my drinks. They just made me feel
                like a prisoner. I'd look at my phone, see the counter, and feel
                worse about myself. Eventually, I just stopped logging.
              </p>

              <p className="mb-6" data-id="element-178">
                I went to therapy for eight months. My therapist was kind. We
                talked about my childhood, my stress, my perfectionism. But
                every session ended the same way—I'd leave feeling slightly
                better, then drink that night anyway.
              </p>

              {/* IMAGE 3: Failed attempts - therapy, apps, supplements */}
              <div className="my-8 rounded-lg overflow-hidden shadow-sm" data-id="element-179">
                <img src="https://cdn.magicpatterns.com/uploads/sQA8uibMb87JX2BcX3hvwA/ChatGPT_Image_10_Ιαν_2026,_11_55_29_π.μ..png" alt="Flat lay of failed attempts: therapy card, sobriety app, supplement bottles, handwritten rules with items crossed out" className="w-full h-auto rounded-lg" data-id="element-180" />
              </div>

              <p className="mb-6" data-id="element-181">
                I tried switching from wine to beer thinking it would be easier
                to stop. It wasn't. I tried going cold turkey for 36 hours once.
                The shaking, the cramps, the overwhelming panic—I thought I was
                dying. I was back to drinking before the second day was over.
              </p>

              <p className="mb-6" data-id="element-182">
                I spent hundreds on supplements. Kudzu. Milk thistle.
                B-vitamins. I took them religiously while drinking wine. Nothing
                changed.
              </p>

              <p className="mb-8 font-bold text-gray-900" data-id="element-183">
                I was exhausted. Financially drained. Emotionally destroyed.
              </p>

              <p className="mb-8" data-id="element-184">And I was running out of hope.</p>

              <p className="mb-8 italic text-gray-700" data-id="element-185">
                If this sounds familiar, keep reading—because what I discovered
                next changed everything.
              </p>

              <h2 className="text-2xl md:text-3xl font-bold text-gray-900 mt-12 mb-6 font-sans" data-id="element-186">
                The Conversation That Changed My Life
              </h2>

              <p className="mb-6" data-id="element-187">
                It was my sister-in-law Rachel who finally told me there was
                another way.
              </p>

              <p className="mb-6" data-id="element-188">
                We were sitting in her backyard after a family dinner. Everyone
                else had gone inside. She handed me a cup of tea and looked at
                me with this knowing expression.
              </p>

              {/* IMAGE 4: Two women having intimate conversation in backyard */}
              <div className="my-8 rounded-lg overflow-hidden shadow-sm" data-id="element-189">
                <img src="https://cdn.magicpatterns.com/uploads/ivE5jD4gCit5MAzygeVjea/ChatGPT_Image_10_Ιαν_2026,_11_55_20_π.μ..png" alt="Two women having an intimate conversation over tea in a backyard with string lights" className="w-full h-auto rounded-lg" data-id="element-190" />
              </div>

              <p className="mb-6" data-id="element-191">
                "Sarah," she said, "I know what's stopping you. You're terrified
                of the 72-hour danger zone. I was too."
              </p>

              <p className="mb-6" data-id="element-192">My throat tightened. She knew.</p>

              <p className="mb-6" data-id="element-193">
                "I found something three months ago," she said. "A patch that
                supports your nervous system so you can get through those 72
                hours safely—without withdrawal symptoms."
              </p>

              <p className="mb-6" data-id="element-194">
                I almost laughed. A patch? After everything I'd tried?
              </p>

              <p className="mb-6 text-lg italic text-gray-700 pl-6 border-l-4 border-[#1E4D3D]" data-id="element-195">
                "I know how it sounds," Rachel said. "But I made it through the
                danger zone without shaking. Without panic attacks. Without my
                heart racing at 3 AM. I didn't end up in the ER. I didn't have a
                seizure. I just... got through it."
              </p>

              <p className="mb-6" data-id="element-196">
                She pulled up her sleeve and showed me a small, discreet patch
                on her upper arm.
              </p>

              {/* IMAGE 5: Woman showing discreet patch on upper arm */}
              <div className="my-8 rounded-lg overflow-hidden shadow-sm" data-id="element-197">
                <img src="https://cdn.magicpatterns.com/uploads/oXi8MQgdXbLKDi3874FUbV/ChatGPT_Image_10_Ιαν_2026,_11_55_22_π.μ..png" alt="Close-up of a discreet transdermal patch on a woman's upper arm" className="w-full h-auto rounded-lg" data-id="element-198" />
              </div>

              <p className="mb-6" data-id="element-199">
                "It regulates your nervous system for 24 hours. Your body gets
                the GABA support and cortisol regulation it needs so you don't
                go into crisis. You're not fighting through withdrawal—you're
                supporting your body so withdrawal doesn't happen."
              </p>

              <p className="mb-8 font-bold text-gray-900" data-id="element-200">
                That night, I ordered it. Not because I fully believed it. But
                because I couldn't spend another year trapped by fear.
              </p>

              <h2 className="text-2xl md:text-3xl font-bold text-gray-900 mt-12 mb-6 font-sans" data-id="element-201">
                Why the 72-Hour Danger Zone Exists (And How to Eliminate It)
              </h2>

              <p className="mb-6" data-id="element-202">
                Over the next hour, Rachel explained something I'd never heard
                from any therapist or any AA meeting I'd nervously Googled.
              </p>

              <p className="mb-8 font-bold text-gray-900" data-id="element-203">
                The 72-hour danger zone exists because of what's happening in
                your nervous system.
              </p>

              <p className="mb-6" data-id="element-204">
                When you drink daily, your brain stops producing enough GABA
                (your calming neurotransmitter) because alcohol has been doing
                that job. At the same time, your body overproduces cortisol to
                counteract alcohol's depressant effects.
              </p>

              <p className="mb-6 font-bold text-gray-900" data-id="element-205">
                So when you suddenly stop drinking, you're left with:
              </p>

              <ul className="space-y-2 mb-8 list-none pl-0" data-id="element-206">
                <li className="flex items-start" data-id="element-207">
                  <span className="text-red-500 mr-2" data-id="element-208">•</span>
                  <span data-id="element-209">
                    Almost no natural GABA (your brain can't calm itself)
                  </span>
                </li>
                <li className="flex items-start" data-id="element-210">
                  <span className="text-red-500 mr-2" data-id="element-211">•</span>
                  <span data-id="element-212">
                    Way too much cortisol (your stress response is in overdrive)
                  </span>
                </li>
              </ul>

              <p className="mb-6 font-bold text-gray-900" data-id="element-213">
                The result? Your nervous system goes into full crisis mode.
              </p>

              <p className="mb-6" data-id="element-214">
                That's why your hands shake. That's why your heart races. That's
                why you wake up at 2 AM convinced you're dying.
              </p>

              <p className="mb-6" data-id="element-215">
                It's not weakness. It's not lack of willpower. It's a
                biochemical emergency.
              </p>

              <p className="mb-8 font-bold text-gray-900" data-id="element-216">
                And here's the critical part: the first 72 hours are when this
                imbalance is most severe. That's why they call it the danger
                zone.
              </p>

              <div className="bg-green-50 border-l-4 border-green-500 p-6 my-8" data-id="element-217">
                <p className="text-green-900 font-medium" data-id="element-218">
                  But what if you could support your nervous system through
                  those 72 hours? What if your body got the GABA support and
                  cortisol regulation it needed so it didn't go into crisis?
                </p>
                <p className="text-green-900 font-bold mt-4" data-id="element-219">
                  That's exactly what this patch does.
                </p>
              </div>

              <p className="mb-6" data-id="element-220">
                It delivers the compounds your body needs—continuously, for 24
                hours—so your nervous system can stabilize naturally.
              </p>

              <p className="mb-8 text-xl font-bold text-gray-900" data-id="element-221">
                You're not white-knuckling through the danger zone. You're
                eliminating the danger zone entirely.
              </p>

              <h2 className="text-2xl md:text-3xl font-bold text-gray-900 mt-12 mb-6 font-sans" data-id="element-222">
                What Happened in the First Week
              </h2>

              <p className="mb-6" data-id="element-223">
                The package arrived three days later in plain brown packaging.
                No one would ever know what was inside.
              </p>

              <p className="mb-6" data-id="element-224">
                I opened it in my bathroom with shaking hands. Inside was a
                month's supply of patches and simple instructions: apply one
                patch to your upper arm or shoulder blade each morning. Wear it
                for 24 hours. Replace daily.
              </p>

              <h3 className="text-xl font-bold text-gray-900 mt-8 mb-4 font-sans" data-id="element-225">
                Day 1:
              </h3>

              <p className="mb-6" data-id="element-226">
                I put on the first patch that Thursday morning. It was small,
                thin, and completely invisible under my shirt.
              </p>

              <p className="mb-6" data-id="element-227">
                Honestly? I didn't feel anything dramatic. But I wasn't
                expecting fireworks. I was just hoping to make it through the
                day without the screaming urge.
              </p>

              <p className="mb-6" data-id="element-228">
                That evening at 7 PM—my usual wine o'clock—something was
                different. The urge was still there, but it was quieter. Like
                someone had turned the volume down.
              </p>

              <p className="mb-6" data-id="element-229">
                I didn't drink that night. And when I went to bed, I braced
                myself for the 3 AM panic attack that always came when I tried
                to quit.
              </p>

              <p className="mb-6 font-bold text-gray-900" data-id="element-230">
                It never came. I woke up once around 4 AM, but I wasn't drenched
                in sweat. My heart wasn't racing. I just... woke up.
              </p>

              <p className="mb-8 text-lg font-bold text-[#1E4D3D]" data-id="element-231">
                Hour 24 of the danger zone: passed.
              </p>

              <h3 className="text-xl font-bold text-gray-900 mt-8 mb-4 font-sans" data-id="element-232">
                Day 2:
              </h3>

              <p className="mb-6" data-id="element-233">
                I woke up expecting the shaking hands. The anxiety. The
                overwhelming panic.
              </p>

              <p className="mb-6 font-bold text-gray-900" data-id="element-234">Nothing.</p>

              <p className="mb-6" data-id="element-235">
                My hands were steady when I made coffee. My chest didn't feel
                tight. I felt tired—probably still adjusting—but I didn't feel
                like I was dying.
              </p>

              <p className="mb-6" data-id="element-236">
                I changed the patch and went to work. That evening, the urge to
                drink was even quieter than the night before.
              </p>

              <p className="mb-8 text-lg font-bold text-[#1E4D3D]" data-id="element-237">
                Hour 48 of the danger zone: passed.
              </p>

              <h3 className="text-xl font-bold text-gray-900 mt-8 mb-4 font-sans" data-id="element-238">
                Day 3:
              </h3>

              <p className="mb-6" data-id="element-239">
                This was it. Hour 72. The peak of the danger zone.
              </p>

              <p className="mb-6" data-id="element-240">
                I woke up naturally at 6 AM. No alarm. No panic. Just... awake.
              </p>

              <p className="mb-6" data-id="element-241">I looked at my hands. Steady.</p>

              <p className="mb-6" data-id="element-242">
                I put my hand on my chest. My heart was beating normally.
              </p>

              <p className="mb-6 font-bold text-gray-900" data-id="element-243">
                The danger zone I'd been terrified of for three years? I was on
                the other side of it.
              </p>

              <p className="mb-8 text-xl font-bold text-[#1E4D3D]" data-id="element-244">
                And I'd gotten through it without a single scary symptom.
              </p>

              <h3 className="text-xl font-bold text-gray-900 mt-8 mb-4 font-sans" data-id="element-245">
                Day 7:
              </h3>

              <p className="mb-6" data-id="element-246">
                By the end of week one, I felt like a different person.
              </p>

              <p className="mb-6" data-id="element-247">
                I was sleeping through the night—deep, restorative sleep. I'd
                wake up at 6 AM feeling actually rested. No grogginess. No brain
                fog. No shame.
              </p>

              <p className="mb-6" data-id="element-248">
                The constant anxiety that had been my shadow for years had
                lifted. I felt calm. Not numb—truly calm.
              </p>

              <p className="mb-6" data-id="element-249">
                My face looked different in the mirror. Less puffy. Less tired.
                My eyes were clearer.
              </p>

              {/* IMAGE 7: Woman looking at herself in mirror - transformation */}
              <div className="my-8 rounded-lg overflow-hidden shadow-sm" data-id="element-250">
                <img src="https://cdn.magicpatterns.com/uploads/tRUsEjhShUeg9oBWpqXoGX/ChatGPT_Image_10_Ιαν_2026,_11_55_26_π.μ..png" alt="Woman looking at herself in a mirror, noticing positive transformation" className="w-full h-auto rounded-lg" data-id="element-251" />
              </div>

              <p className="mb-6 font-bold text-gray-900" data-id="element-252">
                But the biggest change? The mental obsession was gone.
              </p>

              <p className="mb-6" data-id="element-253">
                I wasn't spending all day thinking about whether I'd drink that
                night. I wasn't making rules or bargaining with myself. I wasn't
                white-knuckling my way through each evening.
              </p>

              <p className="mb-8" data-id="element-254">I was just... living. Present. Free.</p>

              <p className="mb-12 text-xl font-bold text-gray-900" data-id="element-255">
                By week two, my daughter was looking at me at breakfast again.
              </p>

              {/* IMAGE 6: Mother and daughter reconnecting - making pancakes together */}
              <div className="my-8 rounded-lg overflow-hidden shadow-sm" data-id="element-256">
                <img src="https://cdn.magicpatterns.com/uploads/e3yQtaMS9MQYPppszvJuFC/ChatGPT_Image_10_Ιαν_2026,_11_55_24_π.μ..png" alt="Mother and teenage daughter making pancakes together in a bright kitchen, reconnecting" className="w-full h-auto rounded-lg" data-id="element-257" />
              </div>

              <h2 className="text-2xl md:text-3xl font-bold text-gray-900 mt-12 mb-6 font-sans" data-id="element-258">
                This isn't just my story. Thousands of women are experiencing
                the same transformation.
              </h2>

              <TestimonialBox testimonials={testimonials} data-id="element-259" />

              <h2 className="text-2xl md:text-3xl font-bold text-gray-900 mt-12 mb-6 font-sans" data-id="element-260">
                Here's What Makes This Different From Everything Else You've
                Tried
              </h2>

              <p className="mb-6" data-id="element-261">
                The patch is called Glisera, and it's specifically designed for
                high-functioning adults whose drinking is driven by chronic
                stress and nervous system dysregulation.
              </p>

              <p className="mb-8 font-bold text-gray-900" data-id="element-262">
                It's not a medication. It's not addictive. And it doesn't
                require you to admit you're an "alcoholic" or attend meetings or
                tell anyone what you're doing.
              </p>

              <p className="mb-8" data-id="element-263">
                It's discreet, private, and science-backed support for your
                overstimulated nervous system.
              </p>

              <p className="mb-6 font-bold text-gray-900" data-id="element-264">
                Here's what's actually in it:
              </p>

              <div className="bg-gray-50 p-6 rounded-lg mb-8" data-id="element-265">
                <h3 className="text-lg font-bold text-gray-900 mb-3 font-sans" data-id="element-266">
                  Kudzu Extract
                </h3>
                <p className="mb-4" data-id="element-267">
                  Used in traditional medicine for over 1,000 years to reduce
                  alcohol cravings. Clinical studies show it helps regulate
                  dopamine response and reduces the compulsion to drink. It
                  doesn't make you sick if you do drink—it simply makes you want
                  it less.
                </p>

                <h3 className="text-lg font-bold text-gray-900 mb-3 font-sans" data-id="element-268">
                  High-Dose B-Vitamins (B1, B6, B12) + Magnesium
                </h3>
                <p className="mb-4" data-id="element-269">
                  Alcohol rapidly depletes these essential nutrients. Without
                  them, your nervous system can't produce calming
                  neurotransmitters like GABA or regulate stress hormones like
                  cortisol. The patch replenishes these nutrients continuously,
                  giving your brain what it needs to feel calm naturally.
                </p>

                <h3 className="text-lg font-bold text-gray-900 mb-3 font-sans" data-id="element-270">
                  Adaptogenic Herb Blend (Ashwagandha, Rhodiola, Holy Basil)
                </h3>
                <p data-id="element-271">
                  These herbs have been clinically shown to lower cortisol
                  levels, restore healthy stress response, and activate your
                  parasympathetic nervous system (the "brake pedal"). They help
                  your body shift out of fight-or-flight mode and into
                  rest-and-digest mode—without alcohol.
                </p>
              </div>

              <h3 className="text-xl font-bold text-gray-900 mt-8 mb-4 font-sans" data-id="element-272">
                The Transdermal Advantage
              </h3>

              <p className="mb-6" data-id="element-273">
                Here's why the patch works when pills and supplements don't:
              </p>

              <p className="mb-6 font-bold text-gray-900" data-id="element-274">
                Alcohol damages your gut lining. That means even if you're
                taking supplements by mouth, your body can't absorb them
                properly.
              </p>

              <p className="mb-6" data-id="element-275">
                But transdermal delivery (through the skin) bypasses your
                digestive system entirely. The ingredients are absorbed directly
                into your bloodstream and delivered continuously for 24 hours.
              </p>

              <p className="mb-8" data-id="element-276">
                No spikes. No crashes. Just steady, reliable support.
              </p>

              <p className="mb-8" data-id="element-277">
                It works while you work. While you sleep. While you're living
                your life.
              </p>

              <div className="bg-blue-50 border-l-4 border-blue-500 p-6 my-8" data-id="element-278">
                <p className="text-blue-900 font-bold text-lg" data-id="element-279">
                  Over 89% of users report significantly reduced cravings within
                  the first 7 days.
                </p>
              </div>

              <h2 className="text-2xl md:text-3xl font-bold text-gray-900 mt-12 mb-6 font-sans" data-id="element-280">
                "But I've Tried Everything... How Is This Different?"
              </h2>

              <p className="mb-6" data-id="element-281">
                I know what you're thinking. I thought the same thing.
              </p>

              <p className="mb-6 italic text-gray-700" data-id="element-282">
                "I've tried supplements before. They didn't work."
                <br data-id="element-283" />
                "I've tried therapy. I kept drinking."
                <br data-id="element-284" />
                "I've tried apps and books and programs. Nothing stuck."
              </p>

              <p className="mb-6 font-bold text-gray-900 text-lg" data-id="element-285">
                Here's why this is different:
              </p>

              <p className="mb-8 font-bold text-gray-900" data-id="element-286">
                Everything else you tried was treating the symptoms.
              </p>

              <ul className="space-y-3 mb-8 list-none pl-0" data-id="element-287">
                <li className="flex items-start" data-id="element-288">
                  <span className="text-red-500 mr-2" data-id="element-289">✗</span>
                  <span data-id="element-290">
                    Apps track your drinking but don't calm your nervous system.
                  </span>
                </li>
                <li className="flex items-start" data-id="element-291">
                  <span className="text-red-500 mr-2" data-id="element-292">✗</span>
                  <span data-id="element-293">
                    Therapy explores your past but doesn't replenish depleted
                    GABA.
                  </span>
                </li>
                <li className="flex items-start" data-id="element-294">
                  <span className="text-red-500 mr-2" data-id="element-295">✗</span>
                  <span data-id="element-296">
                    AA focuses on abstinence but doesn't address cortisol
                    overload.
                  </span>
                </li>
                <li className="flex items-start" data-id="element-297">
                  <span className="text-red-500 mr-2" data-id="element-298">✗</span>
                  <span data-id="element-299">
                    Pills and supplements get destroyed in your damaged gut
                    before they can help.
                  </span>
                </li>
              </ul>

              <p className="mb-8 font-bold text-gray-900 text-xl" data-id="element-300">
                Glisera targets the root cause: your overstimulated nervous
                system.
              </p>

              <p className="mb-8" data-id="element-301">
                When your body gets the support it's been desperately
                lacking—when cortisol regulates, when GABA replenishes, when
                your nervous system can finally shift gears naturally—the
                craving simply fades.
              </p>

              <p className="mb-12 font-bold text-gray-900" data-id="element-302">
                You're not fighting it. You're not white-knuckling it. You're
                not using willpower.
              </p>

              <p className="mb-12 text-xl font-bold text-gray-900" data-id="element-303">
                You just... don't want it anymore.
              </p>

              <div className="bg-gray-50 p-8 rounded-lg my-12" data-id="element-304">
                <h3 className="text-xl font-bold text-gray-900 mb-6 font-sans" data-id="element-305">
                  Common Questions
                </h3>

                <div className="space-y-6" data-id="element-306">
                  <div data-id="element-307">
                    <h4 className="font-bold text-gray-900 mb-2" data-id="element-308">
                      "Will people know I'm wearing it?"
                    </h4>
                    <p className="text-gray-700" data-id="element-309">
                      No. The patch is small, thin, and flesh-toned. You wear it
                      on your upper arm or shoulder blade—completely hidden
                      under normal clothing. It stays on through showers,
                      workouts, and sleep.
                    </p>
                  </div>

                  <div data-id="element-310">
                    <h4 className="font-bold text-gray-900 mb-2" data-id="element-311">
                      "What if I'm not ready to quit completely?"
                    </h4>
                    <p className="text-gray-700" data-id="element-312">
                      You don't have to. This isn't an abstinence program. Many
                      people find they can moderate once their nervous system is
                      supported. Others discover they prefer life without
                      alcohol. Either way, you're in control—not the craving.
                    </p>
                  </div>

                  <div data-id="element-313">
                    <h4 className="font-bold text-gray-900 mb-2" data-id="element-314">
                      "I'm scared to hope again..."
                    </h4>
                    <p className="text-gray-700" data-id="element-315">
                      I understand. After every failed attempt, hope feels
                      dangerous.
                    </p>
                    <p className="text-gray-700 mt-2 font-bold" data-id="element-316">
                      But here's the truth: you didn't fail because you're weak.
                      You failed because you were trying to solve a biological
                      problem with behavioral solutions.
                    </p>
                    <p className="text-gray-700 mt-2" data-id="element-317">
                      This is different. And it comes with a 60-day money-back
                      guarantee. If it doesn't work, you get every penny back.
                      No questions asked.
                    </p>
                    <p className="text-gray-700 mt-2 italic" data-id="element-318">
                      You have nothing to lose except the next 3 AM panic
                      attack.
                    </p>
                  </div>
                </div>
              </div>

              <CTASection variant="primary" data-id="element-319" />

              <h2 className="text-2xl md:text-3xl font-bold text-gray-900 mt-16 mb-6 font-sans" data-id="element-320">
                One Last Thing
              </h2>

              <p className="mb-6" data-id="element-321">
                That Tuesday morning when Emma wouldn't look at me at
                breakfast—that was four months ago.
              </p>

              <p className="mb-6" data-id="element-322">
                This morning, she came into the kitchen, sat down next to me,
                and asked if I wanted to go for a walk after school.
              </p>

              <p className="mb-6" data-id="element-323">
                We walked for an hour. We talked about her friends, her stress
                about exams, her dreams for college.
              </p>

              {/* IMAGE 8: Mother and daughter walking together - happy ending */}
              <div className="my-8 rounded-lg overflow-hidden shadow-sm" data-id="element-324">
                <img src="https://cdn.magicpatterns.com/uploads/eXDuJs7i6veAqvzjTp6k1m/ChatGPT_Image_10_Ιαν_2026,_11_55_28_π.μ..png" alt="Mother and teenage daughter walking together on a tree-lined street, arms linked, happy" className="w-full h-auto rounded-lg" data-id="element-325" />
              </div>

              <p className="mb-6 font-bold text-gray-900" data-id="element-326">
                She told me she's proud of me.
              </p>

              <p className="mb-8" data-id="element-327">
                I can't describe what that felt like. To have my daughter back.
                To have myself back.
              </p>

              <p className="mb-8 text-xl font-bold text-gray-900" data-id="element-328">
                The shame dies when you take action.
              </p>

              <p className="mb-6" data-id="element-329">
                Your nervous system has been flooded with stress hormones for
                years. It's not your fault you've been using alcohol to cope.
                But now you know there's another way.
              </p>

              <p className="mb-12" data-id="element-330">
                You deserve to feel calm. You deserve to sleep through the
                night. You deserve to be present. You deserve your life back.
              </p>

              <p className="mb-12 font-bold text-gray-900 text-xl" data-id="element-331">
                And it starts with one simple decision.
              </p>

              <CTASection variant="final" data-id="element-332" />
            </div>
          </article>

          {/* Sidebar Column */}
          <aside className="hidden lg:block w-[35%]" data-id="element-333">
            <ProductSidebar data-id="element-334" />
          </aside>
        </div>
      </main>

      <StickyBottomBar data-id="element-335" />
    </div>;
}